const emptyTeam = {
    teamName: '',
    gitRepositoryUrl: '',
    customData_country: 'World',
    customData_peopleAmount: '',
    customData_email: '',
};

export default emptyTeam;
